module.exports = __webpack_public_path__ + "static/media/atef4.2539927c.webp";